import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  role: "status",
  "aria-live": "polite",
  class: "ellipsis-container"
}
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none"
}


import { IonSkeletonText } from "@ionic/vue";

interface Props {
  quantity: number;
  activeIndex: number;
  isLoading?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressEllipsis',
  props: {
    quantity: {},
    activeIndex: {},
    isLoading: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isLoading)
      ? (_openBlock(), _createBlock(_unref(IonSkeletonText), {
          key: 0,
          "aria-hidden": true,
          animated: true,
          style: {"width":"100%","min-width":"80px","height":"20px"}
        }))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.quantity, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "ellipsis-item",
            key: item,
            "aria-hidden": true
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_2, [
              _createElementVNode("circle", {
                cx: "6",
                cy: "6",
                r: "6",
                class: _normalizeClass(item - 1 === __props.activeIndex ? 'active' : 'inactive')
              }, null, 2)
            ]))
          ]))
        }), 128))
  ]))
}
}

})